import React from "react";
import { Link } from "react-router-dom";

export function LinkToSource(props: React.PropsWithChildren<{ name: string }>) {
  return <Link to={`/source/${props.name}`}>{props.children}</Link>;
}
